export default {"src":"/_next/static/image/public/images/syncing.a24bf9fd8c050829d7bd3fdb5006e3d1.gif","height":406,"width":406};